import { render, staticRenderFns } from "./LocalTaxesTable.vue?vue&type=template&id=5967c2ec"
import script from "./LocalTaxesTable.vue?vue&type=script&lang=js"
export * from "./LocalTaxesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports